import axios from 'axios';
import { ApiConfig } from '../constants/apiConfig';
import { studentHeaders } from './apiClient';

export const ajukanIzin = async ({ fotoFile, keterangan, jenisIzin }) => {
  try {
    const formData = new FormData();
    formData.append('status', 'menunggu');
    formData.append('jenis_izin', jenisIzin);
    formData.append('keterangan', keterangan);
    formData.append('foto', fotoFile);

    const response = await axios.post(`${ApiConfig.baseUrl}/absensi`, formData, {
      headers: {
        ...studentHeaders(),
        Accept: 'application/json',
      },
    });

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    console.error('Error ajukan izin:', error);
    const message = error.response?.data?.message || 'Gagal mengirim izin';
    return {
      success: false,
      message,
    };
  }
};
